import React, { ReactElement } from 'react';
import NumberFormat from 'react-number-format';

export interface INumberFormatView {
  amount: number | string;
  prefix?: string;
  thousandsGroupStyle?: any;
  fixedDecimalScale?: boolean;
  policyGuideCard?: boolean;
}

const NumberFormatView = (props: INumberFormatView): ReactElement => {
  const {
    amount,
    prefix,
    thousandsGroupStyle,
    fixedDecimalScale,
    policyGuideCard,
  } = props;

  const isValidNumber = !isNaN(Number(amount)) && amount !== '' && amount !== null && amount !== undefined;

  if (policyGuideCard && !isValidNumber) {
    return <span>Not Disclosed</span>;
  }

  return (
    <NumberFormat
      value={isValidNumber ? amount : 0}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={2}
      prefix={prefix || ''}
      displayType={'text'}
      thousandsGroupStyle={thousandsGroupStyle || 'lakh'}
      thousandSeparator={true}
      renderText={(value: any): any => <span>{value}</span>}
    />
  );
};

export default NumberFormatView;
